const ReferDetailReducers = (state = {}, action) => {
  switch (action.type) {
    case "storeReferDetail":
      return action.payload;
    default:
      return state;
  }
};
export default ReferDetailReducers;
